import { Component } from '@angular/core';
import { BaseInheritedMetadataInputComponent } from '../base-inherited-metadata-input-component/base-inherited-metadata-input.component';

@Component({
  selector: 'app-inherited-metadata-input',
  templateUrl:
    '../base-inherited-metadata-input-component/base-inherited-metadata-input.component.html',
  styleUrls: [
    '../base-inherited-metadata-input-component/base-inherited-metadata-input.component.scss'
  ]
})
export class InheritedMetadataInputComponent extends BaseInheritedMetadataInputComponent {
  override inheritanceLabel = 'Primijeni na niže jedinice';

  protected getInheritedControlName(): string {
    return 'en~jedinica_gradiva~primjeni_na_nize_attrs';
  }
}
